<div #mainWrapper class="w-full">
  <div #pageActionWrapper class="page-action-wrapper" sxCenterize="col">
    <ng-content></ng-content>
  </div>
</div>